import React, { MouseEvent } from 'react';

interface Output {
  open: boolean;
  anchorEl: null | HTMLElement;
  toggle(event: { currentTarget: HTMLElement }): void;
  close(event?: MouseEvent): void;
}

export default function useOcPopover(onClose?: () => void, onOpen?: () => void): Output {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const toggle = (event: { currentTarget: HTMLElement; stopPropagation?: () => {} }) => {
    event?.stopPropagation?.();
    setAnchorEl(event.currentTarget);
    if (event && onOpen) {
      onOpen();
    }
  };

  const close = (event?: MouseEvent) => {
    event?.stopPropagation?.();
    onClose?.();
    setAnchorEl(null);
  };

  return {
    anchorEl,
    open,
    toggle,
    close
  };
}
